import React from 'react';
import Link from 'components/common/link';
import { BlogPostContentType } from 'constants/blog';
import { BLOG_INSTAFEED_DEMO1, BLOG_INSTAFEED_DEMO2, BLOG_INSTAFEED_MAIN } from 'constants/images';
import { BlogPost } from 'containers/blog/post/types';
import { theme } from 'utils/theme';

const InstaFeedPost: BlogPost = {
  id: 'instafeed',
  title: 'InstaFeed',
  subtitle: 'Let automation solve the FOMO',
  previewImage: BLOG_INSTAFEED_MAIN,
  date: new Date('9 Feb 2021'),
  content: [
    {
      type: BlogPostContentType.TITLE,
      content: 'InstaFeed',
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: 'Let automation solve the FOMO',
    },
    {
      type: BlogPostContentType.POST_INFO,
      content: '9 Feb 2021 · 3 minute read',
    },
    {
      type: BlogPostContentType.FULL_IMAGE,
      content: BLOG_INSTAFEED_MAIN,
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        "I observed a pattern especially since the pandemic started. I check social media too often, too much. I can't figure out how much is curiosity and how much is the fear of missing out, but it became instinctual. I would jump on Instagram and scroll addictively, even though I'm interested in maybe 5% of the profiles I'm following. ",
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'I thought building something that would filter the signal out of the noise would be a great idea.',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'Instead of actively scrolling social media, InstaFeed, the small app I built, would do it for me. Users can set the automatic checking frequency and the time of the day they want to receive the update in their email inbox, just like in the picture below.',
    },
    {
      type: BlogPostContentType.NORMAL_IMAGE,
      content: BLOG_INSTAFEED_DEMO1,
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        "At the time of this post, it has been running for only a few days, but I already feel that I stay up to date without any scrolling. I'm receiving the posts I care about every afternoon, which makes me feel I'm not missing any important update, landscape, or story.",
    },
    {
      type: BlogPostContentType.NORMAL_IMAGE,
      content: BLOG_INSTAFEED_DEMO2,
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        "Sometimes nothing interesting happens, so I thank myself for building this app so I don't have to scroll multiple times a day without seeing anything meaningful.",
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'More on the app: built using Selenium, Django, and Docker, it is designed to be easily deployed on a private virtual machine, with minimal changes needed. I hope this simple automation idea would reach more people, save their time and release the FOMO.',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'Further plans include an extension to other social media sites in the same way, with a daily update if anything important happens.',
    },
    {
      type: BlogPostContentType.TEXT,
      content: (
        <>
          Check and try it on{' '}
          <Link
            newTab
            href="https://github.com/MihaiAnton/InstaFeed"
            color={theme.customColors.linkBlue}
          >
            GitHub
          </Link>
          .
        </>
      ),
    },
  ],
};

export default InstaFeedPost;
